import { DatePicker } from 'antd';
import { AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { USER_DATE_FORMAT } from 'shared/constants/date';
import type { DateFieldProps } from './types';
import { FILTER_FORM_NAMES } from '../../../constants';

export const DateField = ({ onChange, placeholder, focusRef }: DateFieldProps) => {
  return (
    <AppFormItem
      name={[FILTER_FORM_NAMES.values, 0]}
      rules={formRules.requiredDate}
      marginless
      withoutExplain
    >
      <DatePicker
        format={USER_DATE_FORMAT}
        showToday={false}
        onChange={(value) => onChange([value])}
        placeholder={placeholder}
        ref={focusRef}
      />
    </AppFormItem>
  );
};
